import {
  ScrollArea,
  TabsContent,
  TabsList,
  TabsTrigger,
  Tabs,
  cn,
} from "web-design-system";
import { useContext } from "react";
import { TransactionOrderType } from "creso-core/constants";
import { useRouter, useSearch } from "@tanstack/react-router";
import { motion } from "motion/react";
import OneTimeForm from "./one-time-form";
import SIPForm from "./sip-form";
import RedemptionForm from "./redemption-form";
import SWPForm from "./swp-form";
import STPForm from "./stp-form";
import SwitchForm from "./switch-form";
import { TransactionContext } from "./transaction-wizard";
import ErrorBoundary from "../../core/components/error-boundary";

export default function TransactionForm() {
  const { selectedOrder, updateContext } = useContext(TransactionContext);

  const { type = TransactionOrderType.PURCHASE, action } = useSearch({
    strict: false,
  });

  const transactionTabType = selectedOrder?.type || type;

  const router = useRouter();

  return (
    <motion.div
      className={cn("flex-1 flex flex-col w-160", action === "view" && "w-0")}
    >
      <ErrorBoundary>
        <ScrollArea className="flex-1 p-4">
          <Tabs
            value={transactionTabType}
            onValueChange={(value) => {
              updateContext?.({
                selectedOrder: null,
              });
              router.navigate({
                to: ".",
                search: (prev) => ({
                  ...prev,
                  type: value as TransactionOrderType,
                }),
                // Tab switching should not add to history
                replace: true,
              });
            }}
            className="flex-1 flex flex-col"
          >
            <TabsList className="w-full sticky top-0 bg-muted z-10">
              <TabsTrigger
                className="flex-1"
                value={TransactionOrderType.PURCHASE}
              >
                One time
              </TabsTrigger>
              <TabsTrigger className="flex-1" value={TransactionOrderType.XSIP}>
                SIP
              </TabsTrigger>
              <TabsTrigger
                className="flex-1"
                value={TransactionOrderType.REDEMPTION}
              >
                Redemption
              </TabsTrigger>
              <TabsTrigger className="flex-1" value={TransactionOrderType.SWP}>
                SWP
              </TabsTrigger>
              <TabsTrigger className="flex-1" value={TransactionOrderType.STP}>
                STP
              </TabsTrigger>
              <TabsTrigger
                className="flex-1"
                value={TransactionOrderType.SWITCH}
              >
                Switch
              </TabsTrigger>
            </TabsList>
            <TabsContent
              className="flex-1 flex flex-col rounded-md"
              value={TransactionOrderType.PURCHASE}
            >
              <OneTimeForm />
            </TabsContent>
            <TabsContent
              className="flex-1 flex flex-col rounded-md"
              value={TransactionOrderType.XSIP}
            >
              <SIPForm />
            </TabsContent>
            <TabsContent
              className="flex-1 flex flex-col rounded-md"
              value={TransactionOrderType.REDEMPTION}
            >
              <RedemptionForm />
            </TabsContent>
            <TabsContent
              className="flex-1 flex flex-col rounded-md"
              value={TransactionOrderType.SWP}
            >
              <SWPForm />
            </TabsContent>
            <TabsContent
              className="flex-1 flex flex-col rounded-md"
              value={TransactionOrderType.STP}
            >
              <STPForm />
            </TabsContent>
            <TabsContent
              className="flex-1 flex flex-col rounded-md"
              value={TransactionOrderType.SWITCH}
            >
              <SwitchForm />
            </TabsContent>
          </Tabs>
        </ScrollArea>
      </ErrorBoundary>
    </motion.div>
  );
}
